export function removeScripts(srcSearchString: string[]) {
  const scripts = document.getElementsByTagName('script');

  for (const script of scripts) {
    srcSearchString.forEach((str) => {
      if (script.src.includes(str)) {
        return script.remove();
      }
    });
  }
}
